function declareWebpackPublicPath() {
    let publicDomainOverride = window.localStorage.getItem('myHealthToolkitClientWebpackPublicDomainOverride');
    let publicDomainComputed = window.location.hostname.startsWith('secure.') ? 'https://' + window.location.hostname.replace('secure.', '') : undefined;
    if (publicDomainOverride) {
        __webpack_public_path__ = publicDomainOverride + process.env.PUBLIC_PATH;
    } else if (publicDomainComputed) {
        __webpack_public_path__ = publicDomainComputed + process.env.PUBLIC_PATH;
    }
}

module.exports = {
    declareWebpackPublicPath
};
